import Vue from 'vue'
import http from '../utils/http';

export default {
    state: {
        chains: null, //independent chains
        channels: null, //team channels
        channels_all: null // all teams channels
    },
    mutations: {
        loadChains(state, payload) {
			state.chains = payload
		},
        loadChannels(state, payload) {
			state.channels = payload
		},
        loadAllChannels(state, payload) {
			state.channels_all = payload
		},
        addChain(state, payload) {
           const index = state.chains.length
			Vue.set(state.chains, index, payload)   
        },
        //to team channels
        addChannel(state, payload) {
           const index = state.channels?.length || 0;
			Vue.set(state.channels, index, payload)   
        },
        addAllChannel(state, payload) {
           const index = state.channels_all?.length || 0;
			Vue.set(state.channels_all, index, payload)   
        },
        editChain(state, payload) {
            const ch = state.chains?.find(chan => chan.id == payload.id)
            const index = state.chains?.indexOf(ch);
            if (!ch) {
                state.chains = payload;
            } else {
                Vue.set(state.chains, index, payload)  
            }   	   
        },
        editChannel(state, payload) {
            const ch = state.channels?.find((chan) => chan.id == payload.id)
            const index = state.channels?.indexOf(ch)
            if (!index) {
                state.channels = payload;
            } else {
                Vue.set(state.channels, index, { ...ch, ...payload }); 
            }  
        },
        addTrademark(state, payload) {
            const channel = state.channels?.find(chan => chan.id == payload.channelId)
            channel?.trademarks.push({ name: payload.trademark })
        },
        removeTrademark(state, payload) {
            const channel = state.channels?.find(chan => chan.id == payload.channelId)
            const trademark_decoded = decodeURIComponent(payload.trademark)
            channel.trademarks = channel.trademarks?.filter(it => it.name !== trademark_decoded)
        },
        deleteChain(state, payload) {
            state.chains = state.chains?.filter(s => s.id !== payload)
        },
        deleteChannel(state, payload) {
            state.channels = state.channels?.filter(s => s.id !== payload)
        },
        deleteAllChannel(state, payload) {
            state.channels_all = state.channels_all?.filter(s => s.id !== payload)
        },
    },
    actions: {
        async fetchChains({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            try {
                const result = await http.get(`/chain/${ payload }`);
                
                if (result) {
                   const chains = await result.data 
                   commit('loadChains', chains)
                }
                               
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async fetchChannels({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)
            //by game & round
            try {
                const result = await http.get(`/channel/game/${payload.gameId}?round=${payload.round}`);
                
                if (result) {
                   const channels = await result.data 
                   commit('loadAllChannels', channels)
                }
                               
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async fetchTeamChannels({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            try {
                const result = await http.get(`/channel/team/${payload.teamId}?gameId=${payload.gameId}&round=${payload.round}`);
                if (result) {
                   const channels = result.data 
                   commit('loadChannels', channels)
                }
                               
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async addChain({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)
            //console.log(payload)

            try {
                const result = await http.post(`/chain`, payload);
                //console.log(result)
                if (result) {
                   const chain = await result.data 
                   commit('addChain', chain)
                }
                               
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async addChannel({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            let team = {};
            let trademarks = [];
            
            if (payload.team) {
                team = payload.team;
                delete payload.team;
            }

            if (payload.trademarks) {
                payload.trademarks.forEach(item => {
                    trademarks.push({ name: item })
                })
            }

            try {
                const result = await http.post(`/channel`, payload);
                //console.log(result)
                if (result) {
                   const chan = await result.data;
                   chan.team = team;
                   chan.trademarks = trademarks;
                   commit('addChannel', chan)
                }
                               
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async addAllChannel({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            let team = {};
            let trademarks = [];
            
            if (payload.team) {
                team = payload.team;
                delete payload.team;
            }

            if (payload.trademarks) {
                payload.trademarks.forEach(item => {
                    trademarks.push({ name: item })
                })
            }

            try {
                const result = await http.post(`/channel`, payload);
                //console.log(result)
                if (result) {
                   const chan = await result.data;
                   chan.team = team;
                   chan.trademarks = trademarks;
                   commit('addAllChannel', chan)
                }
                               
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async editChain({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)
            console.log(payload)

            try {
                await http.put(`/chain/${payload.id}`, payload);
                //console.log(result)
                commit('editChain', payload)            
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async editChannel({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)
            
            const id = payload.id;
            
            try {
                await http.put(`/channel/${id}`, payload);
                             
                commit('editChannel', payload)            
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async addTrademarkToChannel({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)
            
            try {
                await http.post(`/channel/trademark/`, payload);
                            
                commit('addTrademark', payload)            
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async removeTrademarkFromChannel({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)
            
            try {
                await http.delete(`/channel/trademark/${payload.channelId}?trademark=${payload.trademark}`);
                            
                commit('removeTrademark', payload)            
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async deleteChain({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            try {
                await http.delete(`/chain/${payload}`);
                //console.log(result)
                commit('deleteChain', payload)            
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async deleteChannel({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            try {
                await http.delete(`/channel/${payload}`);
                //console.log(result)
                commit('deleteChannel', payload)            
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
         async deleteAllChannel({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            try {
                await http.delete(`/channel/${payload}`);
                //console.log(result)
                commit('deleteAllChannel', payload)            
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async calculateIndependent({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)
            //by game & round
            try {
                const result = await http.get(`/channel/calculate_independent/${payload.gameId}?round=${payload.round}`);
                
                if (result) {
                   const channels = await result.data 
                   commit('loadAllChannels', channels)
                }
                               
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async calculateFranchiseNumber({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)
            //getting all channels by game & round
            try {
                const result = await http.get(`/channel/calculate_franchise/${payload.gameId}?round=${payload.round}`);
                if (result) {
                   const channels = await result.data 
                   commit('loadAllChannels', channels)
                }              
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async channelsTransition({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)
            //by game & round
            try {
                await http.get(`/channel/transition/${payload.gameId}?round=${payload.round}`);             
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
    },
    getters: {
        chains(state) {
            return state.chains;
        },
        channels(state) {
            return state.channels;
        },
        channels_all(state) {
            return state.channels_all;
        }
    }
}